import { useState } from 'react';
import {
  Alert,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Iconify from '@/components/iconify';
import { setStorageItem } from '@/lib/localStorage';
import { useLoginMutation } from '@/api/login/login.ts';
import { StorageKeys } from 'src/enums/StorageKeys.enum';

export default function LoginForm() {
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');

  const { mutateAsync, isPending, error } = useLoginMutation();

  const handleClick = (event: any) => {
    event.preventDefault();

    mutateAsync({
      email,
      password,
    }).then((data) => {
      setStorageItem(StorageKeys.token, data.token);
      window.location.href = '/';
    });
  };

  return (
    <form>
      <Stack spacing={3}>
        {error && (
          <Alert sx={{ marginBottom: 2 }} severity='error'>
            {error.message || 'Authentication failed. Please try again.'}
          </Alert>
        )}

        <TextField
          name='email'
          label='Email address'
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />

        <TextField
          name='password'
          label='Password'
          type={showPassword ? 'text' : 'password'}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position='end'>
                <IconButton
                  onClick={() => setShowPassword(!showPassword)}
                  edge='end'
                >
                  <Iconify
                    icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'}
                  />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      <Stack
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        sx={{ my: 2 }}
      ></Stack>

      <LoadingButton
        fullWidth
        size='large'
        type='submit'
        variant='contained'
        onClick={handleClick}
        disabled={email.length === 0 || password.length === 0}
        loading={isPending}
      >
        Login
      </LoadingButton>
    </form>
  );
}
